import React, { useEffect, useState } from "react";
import axios from "axios";
import { WiHumidity } from "react-icons/wi";
import { TbTemperatureCelsius } from "react-icons/tb";

function Weather() {
  const [country, setCountry] = useState(null);
  const [city, setCity] = useState(null);
  const [time, setTime] = useState(null);
  const [temp, setTemp] = useState(null);
  const [humidity, setHumidity] = useState(null);

  useEffect(() => {
    axios
      .get(
        `http://api.weatherstack.com/current?access_key=${process.env.REACT_APP_API_KEY}&query=Tangerang`
      )
      .then((response) => {
        setCountry(response.data.location.country);
        setCity(response.data.location.name);
        setTime(response.data.location.localtime);
        setTemp(response.data.current.temperature);
        setHumidity(response.data.current.humidity);
      });
  }, []);

  return (
    <div className="weather-container">
      <div className="weather-left">
        <div className="weather-city">
          {country}, {city}
        </div>
        <div className="weather-time">{time}</div>
      </div>
      <div className="weather-temp">
        {temp} <TbTemperatureCelsius style={{ fontSize: "40px" }} />
      </div>
      <div className="weather-humidity">
        {humidity}
        <WiHumidity style={{ fontSize: "40px" }} />
      </div>
    </div>
  );
}

export default Weather;
